import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  menuOpen = false;
  isScrolled = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollPosition > window.innerHeight * 0.8;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  scrollToTop(event: Event): void {
    event.preventDefault();
    if (this.router.url === '/sobre-nos') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.router.navigate(['/sobre-nos']);
    }
  }

  scrollToContato(event: Event): void {
    event.preventDefault();
    const el = document.getElementById('contato');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      });
    }
  }

}
